// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var m = require('mobx');
  var constants = require('logic/data/Izenda.LicenseCheckerConstants');
  var { findLast } = require('lodash/fp');
  function DatabaseConfiguration() {
    // for first time to get connection info
    this.hasValidConnection = false;
    this.differentDatabase = true;

    m.extendObservable(this, {
      supportedDatabaseType: [],
      connectionInfo: {},
      isValidConnection: false,
      validatedConnection: false,
      validationError: '',
      serverTypeName: function() {
        var serverTypeId = this.connectionInfo.serverTypeId;

        return findLast({ id: serverTypeId }, this.supportedDatabaseType).name;
      }
    });
  }

  /**
   * Get list of supported database types
   */
  DatabaseConfiguration.prototype.updateSupportedDatabaseType = function(supportedDatabaseTypes) {
    this.supportedDatabaseType = supportedDatabaseTypes;
  };

  /**
   * reset database connection information
   */
  DatabaseConfiguration.prototype.resetDataInfo = function() {
    this.isValidConnection = false;
  };

  /**
   * read connection status
   * @param  {object} status [status receive from api]
   */
  DatabaseConfiguration.prototype.readTestConnectionStatus = function(status) {
    m.transaction(
      function() {
        // After Validated connection string will be hidden
        this.validatedConnection = true;
        this.differentDatabase = status.differentDatabase;

        if (!status.success) {
          this.validationError = status.messages && status.messages[0];
        }
      }.bind(this)
    );
  };

  /**
   * set isValidConnection value
   * @param {object} response
   * @param {string} connectionString
   */
  DatabaseConfiguration.prototype.setValidConnection = function(response) {
    this.isValidConnection = response.success;
  };

  /**
   * [update connection info]
   * @param  {object} response [response from api]
   */
  DatabaseConfiguration.prototype.updateConnectionInfo = function(response) {
    m.transaction(
      function() {
        this.validationError = '';
        this.connectionInfo = response;
        if (this.connectionInfo.serverTypeId === constants.SERVER_TYPE.UNKNOWN) {
          this.connectionInfo.serverTypeId = constants.SERVER_TYPE.MSSQL; // default server type is MSSQL
        }
        this.hasValidConnection = this.isValidConnection = this.validatedConnection = !!response.connectionString;
      }.bind(this)
    );
  };

  /**
   * Update server type
   * @param {type} value
   */
  DatabaseConfiguration.prototype.updateServerType = function(value) {
    this.connectionInfo.serverTypeId = value;
    this.connectionInfo.connectionString = '';
    this.resetConnectionStatus();
  };

  /**
   * Update connection string
   * @param {type} value
   */
  DatabaseConfiguration.prototype.updateConnectionString = function(value) {
    this.connectionInfo.connectionString = value;

    this.resetConnectionStatus();
  };

  /**
   * Reset connection string
   */
  DatabaseConfiguration.prototype.resetConnectionString = function() {
    this.connectionInfo.connectionString = '';
  };

  /**
   * Reset connection status
   * @param {type} key
   * @param {type} value
   */
  DatabaseConfiguration.prototype.resetConnectionStatus = function() {
    if (this.validatedConnection) {
      this.validatedConnection = false;
    }
  };

  module.exports = DatabaseConfiguration;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.DatabaseConfiguration.js